<template>

    <div class="w-full h-screen" ref="map-wrapper">

        <!--        <GmapMap v-if="mapDimensions"-->
        <GmapMap

                ref="mapRef"
                :center="center"
                :zoom="13"
                map-type-id="hybrid"
                :style="mapDimensions"
        >

            <!--            <GmapInfoWindow :opened="true" :options="{position: {lat:48.219434,lng:17.917805},pixelOffset: {  width: 0, height: -35    }}">-->
            <GmapInfoWindow :opened="infoWindow.opened" :options="infoWindow" @closeclick="closeInfoWindow()">


                <div style="width:300px" class="mt-1 rounded overflow-hidden shadow-lg">
                    <div :class="[infoWindow.type !== 'point'?'block text-center mx-auto':'']"
                         class="font-bold text-xl mb-2">
                        {{infoWindow.title}}
                    </div>

                    <img v-if="infoWindow.type === 'point'"
                         class="w-full"
                         @click="$emit('show-full-image',infoWindow.photo_2)"
                         :src="infoWindow.photo_2"
                         alt="Sunset in the mountains">

                    <div v-if="infoWindow.description !== ''" class="px-2 py-2">

                        <p class="text-gray-700 text-base">
                            {{infoWindow.description}}
                        </p>

                    </div>
                    <!--                        <div v-if="infoWindow.tags.length > 0" class="px-2 pt-2 pb-1">-->
                    <!--                            <span v-for="(tag,tagindex) in infoWindow.tags" :key="'infowindow-tag-'+tagindex"-->
                    <!--                                  class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2 mb-2">#{{tag}}</span>-->
                    <!--                        </div>-->


                </div>

            </GmapInfoWindow>

            <template v-for="(item,index) in items">
                <GmapPolyline
                        v-if="item.type === 'road'"
                        :key="'custom-gmap-road-'+index"
                        :path="item.path"
                        :options="{
                        path:item.path,
                        strokeColor: item.id === animateMarkerId ? '#ecf0f1' : item.color,
                        strokeWeight: 4,
                        strokeOpacity: 1
                    }"
                />
            </template>


            <template v-for="(item,index) in items">


                <gmap-marker v-if="item.type === 'point'"
                             :key="'custom-gmap-marker-'+index"
                             :animation="item.id === animateMarkerId ? 1 : 0"
                             :icon="item.icon"

                             :position="item.position"
                             :clickable="true"
                             @click="markerClicked(item)"/>

                <template v-else>

                    <gmap-marker :key="'custom-gmap-marker-0-'+index"
                                 :animation="item.id === animateMarkerId ? 1 : 0"
                                 :icon="item.id === animateMarkerId ?'/assets/icons/bike-active.svg' :'/assets/icons/bike.svg'"
                                 :position="item.path[0]"
                                 :clickable="true"
                                 @click="markerClicked(item,item.path[0])"/>

                    <gmap-marker :key="'custom-gmap-marker-1-'+index"
                                 :animation="item.id === animateMarkerId ? 1 : 0"
                                 :icon="item.id === animateMarkerId ?'/assets/icons/bike-active.svg' :'/assets/icons/bike.svg'"
                                 :position="item.path[item.path.length - 1]"
                                 :clickable="true"
                                 @click="markerClicked(item,item.path[item.path.length - 1])"/>

                </template>


            </template>


            <!--            <GmapMarker v-for="(item,index) in items"-->
            <!--                       -->

            <!--                        :label="item.label"-->
            <!--                        :position="item.position"-->
            <!--                        :animation="0"-->
            <!--                        :clickable="true"-->
            <!--                        :icon="(item.type === 'point'? '/assets/icons/monument.svg' :'/assets/icons/bike.svg')"-->
            <!--                        :draggable="false"-->
            <!--                        :shape="shape"-->
            <!--                        @click="markerClicked(item)"-->
            <!--            />-->

            <!--            </template>-->


        </GmapMap>

    </div>

</template>

<script>
    export default {
        name: "map",
        props: ['items', 'animateMarkerId'],
        data() {
            return {

                infoWindow: {
                    opened: false,
                    position: {
                        lat: 48.219434,
                        lng: 17.917805
                    },
                    pixelOffset: {
                        width: 0,
                        height: -35
                    },
                    title: '',
                    description: '',
                    tags: []
                },

                shape: {
                    coords: [10, 10, 10, 15, 15, 15, 15, 10],
                    type: 'poly',
                },

                c: {
                    path: [
                        {lat: 48.2879805565, lng: 18.0515778065},
                        {lat: 48.2876660675, lng: 18.05108428},
                        {lat: 48.2883942872, lng: 18.0481445789},
                        {lat: 48.2876808196, lng: 18.0460631847},
                        {lat: 48.2866099477, lng: 18.0437457561},
                        {lat: 48.2847250253, lng: 18.0414283276},
                        {lat: 48.2853821665, lng: 18.0421578884},
                        {lat: 48.281583488, lng: 18.0409991741},
                        {lat: 48.281069845, lng: 18.0365359783},
                        {lat: 48.2782065868, lng: 18.0302596092},
                        {lat: 48.2775782794, lng: 18.0238223076},
                        {lat: 48.2730936259, lng: 18.0110764503},
                        {lat: 48.2696664333, lng: 18.0058836937},
                        {lat: 48.2658241689, lng: 18.0001544952},
                        {lat: 48.2620241493, lng: 18.0058193207},
                        {lat: 48.2563673705, lng: 17.9971075058},
                        {lat: 48.2500950247, lng: 17.9903483391},
                        {lat: 48.2420926541, lng: 17.9777312279},
                        {lat: 48.2433646917, lng: 17.9763686657},
                        {lat: 48.2403063029, lng: 17.9640948772},
                        {lat: 48.2373055816, lng: 17.9661118984},
                        {lat: 48.2325030863, lng: 17.9584729671},
                        {lat: 48.2356191427, lng: 17.9536664486},
                        {lat: 48.2392133027, lng: 17.9509413242},
                        {lat: 48.2362977415, lng: 17.9444181919},
                        {lat: 48.2347541302, lng: 17.9447185993},
                        {lat: 48.2325600833, lng: 17.9332494736},
                        {lat: 48.2318459451, lng: 17.932240963},
                        {lat: 48.2310312241, lng: 17.9314684868},
                        {lat: 48.229797408, lng: 17.9276530445},
                        {lat: 48.2295875251, lng: 17.9277777672},
                        {lat: 48.2286581397, lng: 17.9259967804},
                        {lat: 48.2280861586, lng: 17.9253530502},
                        {lat: 48.2291637361, lng: 17.9230195284},
                        {lat: 48.2320370525, lng: 17.9206806421},
                        {lat: 48.2313651592, lng: 17.9190927744},
                        {lat: 48.2304646075, lng: 17.916238904},
                        {lat: 48.2228954136, lng: 17.904984355},
                        {lat: 48.2242392004, lng: 17.9020661116},
                        {lat: 48.2215516269, lng: 17.8957146406},
                        {lat: 48.2159330696, lng: 17.8890842199},
                        {lat: 48.2084973156, lng: 17.8820461035},
                        {lat: 48.2087836415, lng: 17.8792566061},
                        {lat: 48.2194782794, lng: 17.8684419394},
                        {lat: 48.224010542, lng: 17.8610819578},
                        {lat: 48.2372177392, lng: 17.8487223387},
                        {lat: 48.2319009304, lng: 17.8357619047},
                        {lat: 48.2304143161, lng: 17.8325003386},
                        {lat: 48.2261831313, lng: 17.8331011534},
                        {lat: 48.2226379216, lng: 17.8287237883},
                        {lat: 48.2251538336, lng: 17.8226298094}
                    ],
                    // path: '48.213035,17.934098|48.212878,17.932671|48.212826,17.930696|48.212867,17.929191|48.211426,17.924002',
                    strokeColor: '#e67e22',
                    strokeWeight: 4,
                    strokeOpacity: 1,
                },

                center: {
                    lat: 48.2244168,
                    lng: 17.8999671,
                },

                paths: [
                    {lat: 48.247913, lng: 17.760455},
                    {lat: 48.297603, lng: 17.991402},
                    {lat: 48.179835, lng: 18.061210},
                    {lat: 48.153485, lng: 17.822635}
                ],


                mapDimensions: null

            }
        },
        watch: {
            mapDimensions(dimensions) {
                if (dimensions) {
                    this.$nextTick(() => {
                        this.$refs.mapRef.$mapPromise.then((map) => {
                            // console.log(map)
                        })
                    })
                }
            }
        },
        computed: {},
        async mounted() {

            // https://roads.googleapis.com/v1/snapToRoads?path=48.213035,17.934098|48.212878,17.932671|48.212826,17.930696|48.212867,17.929191|48.211426,17.924002&interpolate=true&key=AIzaSyDrebBeA3ytx5-KRXlh-jOAz2RCmbmzGss


            this.$nextTick(() => {

                const mapBounding = this.$refs['map-wrapper'].getBoundingClientRect()
                this.mapDimensions = {
                    width: mapBounding.width + 'px',
                    height: mapBounding.height + 'px'
                }

            })

        },
        methods: {

            closeInfoWindow() {
                this.infoWindow.opened = false
            },

            markerClicked(marker, position = null) {
                this.infoWindow.position = !position ? marker.position : position
                this.infoWindow.tags = marker.tags
                this.infoWindow.title = marker.title
                this.infoWindow.description = marker.description
                this.infoWindow.photo_2 = marker.photo_2
                this.infoWindow.type = marker.type
                this.infoWindow.opened = true
            },


            initializeMap() {

            }
        }
    }
</script>

<style>
    .gm-style .gm-style-iw-c {

    }
</style>